import React from "react";
import {
  CircularProgress,
  FlatButton,
  RaisedButton,
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from "material-ui";
import * as RequisitionTypes from "../../../general/paper-state";
import * as TimeUtils from "../../../general/time-utils";

export default class PaperTable extends React.Component {
  render() {
    return (
      <div>
        <Table selectable={false} fixedHeader={false} style={{ width: "100%" }}>
          <TableBody displayRowCheckbox={false} showRowHover={true}>
            <TableRow>
              <TableHeaderColumn>Cod</TableHeaderColumn>
              <TableHeaderColumn>Compartiment</TableHeaderColumn>
              <TableHeaderColumn>Articole</TableHeaderColumn>
              <TableHeaderColumn>Data crearii</TableHeaderColumn>
              <TableHeaderColumn>Stare</TableHeaderColumn>
              <TableHeaderColumn>Valoare</TableHeaderColumn>
              <TableHeaderColumn>Actiuni</TableHeaderColumn>
              {this.props.canSetPaperAsPrinted && (
                <TableHeaderColumn>FINALIZATA?</TableHeaderColumn>
              )}
            </TableRow>

            {this.props.data.map((t, i) => {
              return (
                <TableRow key={t.id}>
                  <TableRowColumn>
                    {t.yearId && t.createdYear
                      ? t.yearId + " / " + t.createdYear
                      : null}
                  </TableRowColumn>
                  <TableRowColumn>{t.department.name}</TableRowColumn>
                  <TableRowColumn>
                    {t.articles &&
                      t.articles.map((a, i) => {
                        let text = a.product.name;
                        if (i !== t.articles.length - 1) {
                          text += ", ";
                        }
                        return text;
                      })}
                  </TableRowColumn>
                  <TableRowColumn>
                    {TimeUtils.getSimpleFormat(t.createdDate)}
                  </TableRowColumn>
                  <TableRowColumn>
                    {RequisitionTypes.isDraft(t.state) ? (
                      <strong>{RequisitionTypes.getTypeForId(t.state)}</strong>
                    ) : (
                      RequisitionTypes.getTypeForId(t.state)
                    )}
                  </TableRowColumn>

                  <TableRowColumn>{t.totalPriceWithVat}</TableRowColumn>

                  <div>
                    <div>
                      {RequisitionTypes.isDraft(t.state) ? (
                        <div>
                          <RaisedButton
                            primary
                            label={"Edit"}
                            onClick={() => this.props.onEditClicked(t)}
                          />

                          <RaisedButton
                            style={{ marginLeft: "10px", marginRight: "10px" }}
                            secondary
                            label={"Delete"}
                            onClick={() => this.props.onDeleteClicked(t)}
                          />
                        </div>
                      ) : (
                        <div>
                          <FlatButton
                            primary
                            label={"Detalii"}
                            onClick={() => this.props.onEditClicked(t)}
                          />
                        </div>
                      )}
                      <span
                        style={{
                          cursor: "pointer",
                          color: "blue",
                          marginLeft: "17px",
                          textDecoration: "underline",
                        }}
                        onClick={() => this.props.onClickPrint(t)}
                      >
                        PRINT
                      </span>
                    </div>
                  </div>

                  {this.props.canSetPaperAsPrinted && (
                    <TableRowColumn>
                      <span>{t.isPrinted}</span>
                      {t.printed ? (
                        <span>FINALIZATA</span>
                      ) : RequisitionTypes.isApproved(t.state) ? (
                        <RaisedButton
                          secondary
                          label={"FINALIZEAZA"}
                          onClick={() => this.props.onSetPaperAsPrinted(t)}
                        />
                      ) : (
                        <span></span>
                      )}
                    </TableRowColumn>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}
